export class NpiOtherName {
  private readonly data: ObjectType<any>;

  constructor(data: ObjectType<any>) {
    if (!data) return;
    this.data = data;
  }

  public toString(): string {
    return [
      this.data?.prefix,
      this.data?.firstName,
      this.data?.middleName,
      this.data?.lastName,
      this.data?.credential,
      this.data?.suffix,
    ]
      .filter(Boolean)
      .join(' ');
  }
}
